import Vue from 'vue'
import App from './App'
import router from './router'

// import blogsInfo from './assets/data/blogsInfo.json'
// import noteList from './assets/data/noteList.json'
//
// Vue.prototype.myData = myData;//这里将所有数据取到并放在实例下(还没学后台，先将就用json放数据)

import 'element-ui/lib/theme-chalk/index.css'
import {Collapse,CollapseItem,Pagination} from 'element-ui'//这里按需引入组件
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(Pagination);

// Vue.use(ElementUI)
import VueResource from 'vue-resource'

Vue.use(VueResource);
import Vuex from 'vuex';

Vue.use(Vuex);


Vue.config.productionTip = false;//设置为 false 以阻止 vue 在启动时生成生产提示。

// 路由跳转并传参
Vue.prototype.$goRoute = function (index, params) {
  console.log(this.$router,params);
  this.$router.push({name: index, params: params});
};

const vuex_store = new Vuex.Store({
  state: {
    blogInfo: {},
    noteList: {},
    linksData:{}
  },
  mutations: {
    blogsInfoSet(state, val) {
      state.blogInfo = val;
    },
    noteListSet(state, val) {
      state.noteList = val;
    },
    linksDataSet(state, val) {
      state.linksData = val;
    }
  }/*,
  actions: {
    blogsInfoSet(context, val) {
      context.commit('blogsInfoSet', val)
    },
    noteListSet(context, val) {
      context.commit('noteListSet', val)
    },
    linksDataSet(context, val) {
      context.commit('linksDataSet', val)
    }
  }*/
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store: vuex_store, //注入到vue
  router,
  render: h => h(App)
});



// WEBPACK FOOTER //
// ./src/main.js